import { jsx as _jsx } from "react/jsx-runtime";
import { useCommandMenuItemsImplementation } from '#pplx/frontend/apps/ask/ask-input/ask-input-computer-command-menu/commandMenuItemsImplementationShared.js';
import { WebCommandMenuItems } from '#pplx/frontend/apps/ask/ask-input/ask-input-computer-command-menu/WebCommandMenuItems.js';
import { memo } from 'react';
export const ComputerModeMenuItems = memo(function ComputerModeMenuItems(props) {
    const Implementation = useCommandMenuItemsImplementation();
    if (Implementation) {
        return _jsx(Implementation, { ...props });
    }
    return _jsx(WebCommandMenuItems, { ...props });
});
//# sourceMappingURL=ComputerModeMenuItems.js.map